import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const AnnouncementBlock = makeShortcode("AnnouncementBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnnouncementBlock slots="heading, text, button" className='ms-announcement-blade' theme="dark" mdxType="AnnouncementBlock" />
    <h3 {...{
      "id": "join-the-beta-program-for-our-new-adobe-pdf-electronic-seal-api"
    }}>{`Join the Beta program for our new Adobe PDF Electronic Seal API`}</h3>
    <p>{`Sign up for the opportunity to try our latest API that helps you verify the identity and integrity of documents using an electronic seal.`}</p>
    <p><a parentName="p" {...{
        "href": "../pricing/contact/sales/seal"
      }}>{`Register now`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      